import posthog from 'posthog-js';

export type StockAccessLevel =
  | 'anonymous'
  | 'within-limit'
  | 'over-limit'
  | 'paid'
  | 'unknown';

export interface StockViewMeta {
  full_ticker: string;
  ticker?: string;
  name?: string;
  sector?: string;
  country?: string;
  access_level?: StockAccessLevel;
  is_authenticated?: boolean;
}

/** User opened a stock page (/stock/TICKER-COUNTRY). */
export function trackStockViewed(meta: StockViewMeta) {
  const pathname = `/stock/${meta.full_ticker}`;
  posthog.capture('stock_viewed', {
    ...meta,
    pathname,
    page: typeof window !== 'undefined' ? window.location.pathname : pathname,
    referrer: typeof document !== 'undefined' ? document.referrer || undefined : undefined,
  });
}
